import { render, staticRenderFns } from "./EditorBlockAudio.vue?vue&type=template&id=33835f44&scoped=true"
import script from "./EditorBlockAudio.vue?vue&type=script&lang=js"
export * from "./EditorBlockAudio.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockAudio.vue?vue&type=style&index=0&id=33835f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33835f44",
  null
  
)

export default component.exports